class ReactFilterNumber extends  React.Component {

    constructor(props) {
        super(props);

        ModulesMixinsOutsideClick._composite(this);

        this.state = {
            isActive: false,
            isExpanded: false,
            more: props.settings.more,
            less: props.settings.less,
            equal: props.settings.equal
        }
    }

    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */
    getValues() {
        this.setState({isActive: this.state.more || this.state.less || this.state.equal ? true : false});
        return this.state;
    }

    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.setState({
            isActive: false,
            more: null,
            less: null,
            equal: null
        });
    }

    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        this.setState(values);
    }

    clearFilter() {
        this.clearValues();
        if(this.props.loadGrid) {
            setTimeout( function(){
                this.props.loadGrid();
            }.bind(this), 50);
        }
    }

    togglePopup() {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    /**
     * Called by "OutsideClick" Mixin to handle outside click
     */
    outsideClickHandle(e) {
        this.setState({
            isExpanded: false
        });
    }

    handleFilterButtons(event) {
        this.setState({
            isExpanded: false
        });

        if(event.target.dataset.button == "apply"){
            this.props.applyFilters();
        }
        if(event.target.dataset.button == "clear"){
            this.props.clearFilters();
        }
    }

    onMoreChange(event) {
        this.setState({more: event.target.value});
    }

    onLessChange(event) {
        this.setState({less: event.target.value});
    }

    onEqualChange(event) {
        this.setState({equal: event.target.value});
    }
    onKeyUp(event) {
        if (event.which == 13) { // search on ENTER
            if(this.props.loadGrid) {
                this.props.loadGrid();

                this.setState({
                    isExpanded: false
                });
            }
        }
    }

    render() {

        var props = this.props;
        var state = this.state;

        var fields = [];

        if (props.settings.type == 'between' || props.settings.type == 'more') {
            fields.push(
                <div key="more-field" className="field-holder">
                    <input type="number" value={state.more} onChange={this.onMoreChange.bind(this)} onKeyUp={this.onKeyUp.bind(this)} placeholder={__d('modules','More Than')} />
                </div>
            );
        }

        if (props.settings.type == 'between'  || props.settings.type == 'less') {
            fields.push(
                <div key="less-field" className="field-holder">
                    <input type="number" value={state.less} onChange={this.onLessChange.bind(this)} onKeyUp={this.onKeyUp.bind(this)} placeholder={__d('modules','Less Than')} />
                </div>
            )
        }

        if (props.settings.type == 'equal') {
            fields.push(
                <div key="equal-field" className="field-holder">
                    <input type="number" value={state.equal} onChange={this.onEqualChange.bind(this)} onKeyUp={this.onKeyUp.bind(this)} placeholder={__d('modules','Equal To')}  />
                </div>
            )
        }

        var holderCls = 'btn-group custom-dropdown-wrapper numeric-filter-wrapper';
        if(this.state.isActive){
            holderCls += ' active';
        }
        if(this.state.isExpanded){
            holderCls += ' expanded';
        }

        var buttons = null;
        if(this.props.applyFilters && this.props.clearFilters){
            buttons = (
                <div className="grid-filter-actions">
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="apply" className="btn btn-primary apply-filter" role="button">{__d('modules','Apply')}</a>
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="clear" className="btn btn-link clear-filter" role="button">{__d('modules','Reset')}</a>
                </div>
            );
        }

        return (
            <div className={holderCls}>
                <div className="custom-dropdown-button">
                    <button type="button" className="btn btn-primary dropdown-toggle custom-dropdown-toggle" ref="outside_click_trigger" onClick={this.togglePopup.bind(this)} data-toggle="custom-dropdown" aria-haspopup="true" aria-expanded="false">
                        {this.props.label}
                    </button>
                </div>
                <div className="custom-dropdown-clear-button">
                    <button type="button" className="btn btn-primary clear-filter" onClick={this.clearFilter.bind(this)}><i/></button>
                </div>
                <div className="card custom-dropdown-popup" ref="outside_click_content">
                    <div className="card-block">
                        <div className="content">
                            {fields}
                            {buttons}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ReactFilterNumber.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    settings: PropTypes.shape({
        more: PropTypes.string,
        less: PropTypes.string,
        equal: PropTypes.string,
        type: PropTypes.string,
        applyFilters: PropTypes.func,
        clearFilters: PropTypes.func,
        loadGrid: PropTypes.func
    })
};